import { AppModule } from 'app/module';
import Template from './template.hbs';
import './styles.scss';

export class CompaniesFilterButtons extends AppModule {
    setTemplate() {
        this.template = Template;
        if (module.hot) {
            module.hot.accept('./template.hbs', () => {
                this.template = Template;
                this.render();
            });
        }
    }

    domBindings() {
        return {
            buttons: ['.m-companiesFilterButtons__buttonRight'],
            branches: ['.m-companiesFilterButtons__branchTag'],
            benefits: ['.m-companiesFilterButtons__benefitTag'],
            states: ['.m-companiesFilterButtons__stateTag'],
            countries: ['.m-companiesFilterButtons__countryTag'],
            businesspageType: ['.m-companiesFilterButtons__brandingTag'],
        };
    }

    domEvents() {
        for (let i = 0; i < this.dom.buttons.length; i += 1) {
            this.dom.buttons[i].addEventListener('click', (e) => this.buttonClicked(e));
        }
    }

    buttonClicked(e) {
        if (e) e.preventDefault();
        const tagId = e.currentTarget.getAttribute('data-id');
        const tagType = e.currentTarget.getAttribute('data-type');
        const searchRequest = this.generateSearchRequest(tagId, tagType);
        this.events.emit('changedFilter', { searchRequest });
    }

    generateSearchRequest(tagId, tagType) {
        return {
            branches: this.fillFilterElements(tagId, tagType, this.dom.branches),
            benefits: this.fillFilterElements(tagId, tagType, this.dom.benefits),
            states: this.fillFilterElements(tagId, tagType, this.dom.states),
            countries: this.fillFilterElements(tagId, tagType, this.dom.countries),
            businesspageType: this.fillFilterElements(tagId, tagType, this.dom.businesspageType),
        };
    }

    fillFilterElements(tagId, tagType, domNodeList) {
        const filters = {};

        for (let i = 0; i < domNodeList.length; i += 1) {
            const id = domNodeList[i].getAttribute('data-id');
            const type = domNodeList[i].getAttribute('data-type');

            if (tagType !== type || tagId !== id) {
                filters[id] = true;
            }
        }

        return filters;
    }
}
